export const FOUNDATION = {
  TW: 'http://www.cnex.org.tw',
  CN: 'http://www.cnex.org.cn',
  HK: 'http://www.cnex.org.hk',
};
